import { useBottomChrome, useBottomLayout } from '@/shared/store/bottomChromeStore';
import { useMediaQuery, NARROW_QUERY } from '@/shared/hooks/useMediaQuery';
import { BRAND } from '@/shared/branding';

// Persistent bottom bar (desktop always; on a phone only when a page puts a
// line in it, D6). On list pages the table's Pagination bar (z-30) renders on
// top of this (z-20) at the same position. <main> reserves pb-[52px].
export function BottomBar() {
  const { band, reserve } = useBottomLayout();
  const narrow = useMediaQuery(NARROW_QUERY);
  const setSlot = useBottomChrome((s) => s.setSlot);
  // A phone list page has a fixed pager but no band: the mask still has to
  // hide the rows scrolling behind the pager, so it follows `reserve`.
  if (!reserve) return null;
  return (
    <>
      {/* Canvas-colored backdrop under/around the bar: masks scrolling content
          so widgets/cards never visually touch the bar (bottom 8px + bar 34px +
          6px gap = 48px band; 6px so the gap survives zoom rounding). */}
      <div aria-hidden className="fixed bottom-0 left-0 right-0 z-band h-[48px] bg-canvas" />
      {band && (
      <div className="fixed bottom-2 left-2.5 right-2.5 z-20 h-[34px] px-6 md:pl-[calc(12px+3.95rem)] md:pr-10
                    bg-surface border border-[#b8c4d6] rounded-xl shadow-sm
                    flex items-center">
        {/* Left slot: pages portal content here (e.g. a document's lifecycle
            audit line) via <BottomBarInfo>. The right end is left clear for
            the floating AI Companion button (--companion-launcher-space). */}
        <div id="bottom-bar-slot" ref={setSlot} className="min-w-0 flex items-center gap-2 pr-[max(12px,calc(var(--companion-launcher-space,140px)-10px))]" />
      </div>
      )}
      {/* The Fritech name at the bar's left end, cut from the login page's logo, at
          the main nav's text size (owner, 2026-11-03). Its own layer, z-40 like
          the launcher, so a list's Pagination bar (z-30) does not cover it; the
          bars' left padding keeps their content clear of it. */}
      {!narrow && (
        <img src="/logo-fritech-name.png" alt={BRAND} data-brand-mark="" width={51} height={12}
          className="fixed bottom-[calc(25px-0.375rem)] left-[23px] z-40 h-[0.75rem] w-auto select-none pointer-events-none" draggable={false} />
      )}
    </>
  );
}
